<template>
  <div class="apply_box">
    <div class="top">根据对您的信息检测，当前可借的金额和期限如下</div>
    <div class="header"
         v-for="(item, index) in orderList"
         :key="'h' + index">
      <div class="loanMoney">{{ item.title }}</div>
      <p class="title">¥{{ item.rightTitle }}</p>
    </div>
    <div class="bg"></div>
    <div class="pro_detail"
         v-for="(item, index) in allList"
         :key="'p' + index">
      <div class="pro_item">
        <h1 class="h1"><span class="line"></span> {{ item.head.title }}</h1>
        <span class="look"
              @click="toPage(item.head.pageUrl)">{{
          item.head.rightTitle
        }}</span>
      </div>
      <div class="pro_item"
           v-for="(itm, idx) in item.content"
           :key="'i' + idx">
        <p>{{ itm.title }}</p>
        <p class="look"
           v-if="itm.toast"
           @click="toShow(itm)">
          {{ itm.rightTitle }} <span class="look_icon"></span>
        </p>
        <p v-if="!itm.toast&&!itm.type">{{ itm.rightTitle }}</p>
        <p v-if="!itm.toast&&itm.type==1">
          <Select v-model="limitModel">
            <Option v-for="(im, id) in itm.rightTitle.split(',')"
                    :value="im"
                    :key="id">{{ im }}期</Option>
          </Select>
        </p>
      </div>
    </div>
    <div class="bg"></div>
    <div class="pro_detail"
         v-for="(item, index) in cardList"
         :key="'pd' + index">
      <div class="pro_item">
        <h1 class="h1"><span class="line"></span> {{ cardJson.title }}</h1>
      </div>
      <!-- 已绑卡 -->
      <div class="card_box"
           v-if="item.isBind > 0">
        <div class="pro_item1">
          <img class="bank_icon left"
               src="../../assets/img/afterLoan/yinlian.png"
               alt="" />
          <p class="bank_name left">{{ item.cardName }}</p>
          <span class="card_num left">&nbsp;{{ item.cardNumber }}</span>
          <!-- <span class="replace_btn right">更换</span> -->
        </div>
        <div class="info_box">
          {{ item.note }}
          <div class="xy_box"
               v-if="footList.length > 0">
            <span class="icon_circle"
                  :class="{ icon_circleAct: isActive }"
                  @click="checkStatus()"></span>
            {{ footJson.describe }}
            <span class="agree"
                  v-for="(itm, idx) in footList"
                  :key="'c' + idx"
                  @click="toPage(itm.pageUrl)">{{ itm.title
              }}<span v-show="footList.length - 1 != idx">、</span></span>
          </div>
        </div>
      </div>
      <!-- 未绑卡 -->
      <div class="card_box"
           v-else>
        <div class="pro_item">
          <p class="btn"
             @click="toBind(item.pageUrl)">
            <span class="bank_btn"></span>添加
          </p>
        </div>
        <div class="info_box"
             v-if="footList.length > 0">
          <div class="xy_box">
            <span class="icon_circle"
                  :class="{ icon_circleAct: isActive }"
                  @click="checkStatus()"></span>
            {{ footJson.describe }}
            <span class="agree"
                  v-for="(itm, idx) in footList"
                  :key="'c' + idx"
                  @click="toBind(itm.pageUrl)">{{ itm.title
              }}<span v-show="footList.length - 1 != idx">、</span></span>
          </div>
        </div>
      </div>
      <!-- <div class="info_box">
        <span class="icon_circle"
              :class="{'icon_circleAct':isActive}"
              @click="checkStatus()"></span>
        {{footJson.describe}}
        <span class="agree"
              v-for="(itm,idx) in footList"
              :key="'c'+idx"
              @click="toPage(itm)">{{itm.title}}<span v-show="footList.length-1 != idx">、</span></span>
      </div> -->
    </div>
    <div class="btn_box"
         v-for="(item, index) in buttonList"
         :key="'b' + index">
      <div class="loan_btn"
           :class="{ pay_btn_succ: isActive && cardList[0].isBind == 1 }"
           @click="toPage(item.pageUrl)">
        {{ item.title }}
      </div>
    </div>

    <!-- 固定底部分期弹窗 -->
    <div class="shadow"
         v-if="isShow"></div>
    <div class="toast"
         v-if="isShow">
      <h1 class="title">
        费用明细 <span class="close_btn"
              @click="toHideFixedToast"></span>
      </h1>
      <Timeline v-if="dataList.length > 0">
        <Timeline-item v-for="(item, index) in dataList"
                       :key="index">
          <div class="box">
            <p class="time">{{ item.period }}期</p>
            <p class="content">
              还款时间: {{ item.repayDay }}
              <span class="money">￥{{ item.repayMoney }}</span>
            </p>
          </div>
        </Timeline-item>
      </Timeline>
    </div>

    <agreeToast :propJson="agreeJson"
                @pageUrl="pageUrl" />
    <applyModal1 :propJson="propJson" />
    <applyModal2 :propJson="propJson1"
                 @toHide="toHide" />
    <Loading :isShow="isShowLoading"></Loading>
  </div>
</template>

<script>
import agreeToast from "@/components/agreeToast";
import applyModal1 from "@/components/applyModal1";
import applyModal2 from "@/components/applyModal2";
import Loading from "@/components/loading";
export default {
  components: {
    applyModal1,
    Loading,
    applyModal2,
    agreeToast
  },
  data () {
    return {
      dataList: [],
      isShow: false,
      limitModel: 0,
      isShowLoading: false,
      agreeJson: {
        isShow: false,
        title: "风险告知书",
        info: `晋商消费金融股份有限公司个人消费贷款
客户知情及风险告知书
尊敬的客户：
您好！欢迎您申请晋商消费金融股份有限公司（下称：“本公司”）个人消费贷款业务。为保证您的权益，现郑重提醒您注意以下事项：
1、请认真阅读并正确理解本告知书及《个人消费贷款合同》各项内容，尤其有关责任限制或免责条款；如您对任何内容持异议，或无法准确理解任一条款含义，请勿进行后续操作。

2、请您确认本贷款为您本人自愿办理，并承诺按时还款。您已同意并授权本公司向中国人民银行金融信用信息基础数据库以及其他经政府有权部门批准合法设立的信息库查询您的个人征信记录、财产、资信等其他相关情况，用于审核您的贷款申请。您的还款记录将会报送至中国人民银行征信系统，违约情况将被记入您的征信记录，可能会影响到您今后办理信用卡、房贷、车贷等各类金融业务。

3、请您确保在申请贷款时已充分了解该笔贷款对应的利息、费用、罚息、滞纳金等收取情况，包括但不限于利率/费率标准、支付方式、服务内容、罚息/滞纳金标准等。

4、（1）若为一般类或耐用类消费贷款，您同意并授权本公司根据《个人消费贷款合同》约定将贷款支付至您的指定账户（包括但不限于个人账户（含虚拟账户）、商品/服务提供方账户）。贷款发放后即按照贷款利/费率计算利息/费用；（2）若为循环授信类贷款，您同意授权本公司对您在授信额度内的用款申请（包括但不限于取现行为，请款申请等）于您请款成功之日开始按照贷款利/费率计算利息/费用。

5、您知晓或同意，您通过线上平台申请贷款可能面临如下风险，该些风险需由您自行承担：
（1）有关法律法规及政策发生变化，导致您无法获得或无法继续获得贷款产品及服务；
（2）因您的过错导致的任何损失，该过错包括但不限于：决策失误、操作不当、遗忘账号密码或账号密码被他人破解、个人信息或个人账户被他人使用、您使用的移动端系统被第三方侵入、您委托他人代理交易时他人恶意或不当操作而造成的损失等；
（3）因您违约导致的不良征信记录风险、被第三方机构进行催收的风险以及诉讼法律风险。
以上并不能揭示您通过线上平台申请贷款的全部风险及全部情形。您在作出贷款申请决策前，应全面了解贷款申请程序和相关信息，谨慎决策，并自行承担全部风险。

6、您在消费过程中所发生的任何纠纷，包括您在消费中因商品/服务质量产生的问题，均不影响您的还款义务。您需按时偿还未清偿款项，直到贷款全部结清。

7、您有义务提供个人真实信息，并保证联系电话、联系地址等联系方式的有效性、安全性和及时更新，以便本公司为您提供服务并与您进行及时有效的联系。您应完全独自承担因通过这些联系方式无法与您取得联系而因此遭受的任何损失或增加任何费用等不利后果。

8、您已知晓，任何以不实信息、虚假交易或联合中介等骗贷的行为，将会被追究民事甚至刑事法律责任。

请您务必在完全理解并同意上述内容、并在充分了解申请本贷款的相关风险和收费标准后，再进行贷款申请；否则，请勿签署《个人消费贷款合同》。`,
        btn: "阅读并同意",
        pageUrl: ""
      },
      propJson: {
        isShow: false,
        title: "费用明细",
        feeDesc: "",
        btn: "确定",
        status: "0",
        periodAmount: "",
        interest: ""
      },
      propJson1: {
        isShow: false,
        title: "费用明细",
        btn: "确定",
        status: "0",
        dataArr: [] //数组
      },
      allList: [],
      orderId: "",
      orderList: [],
      bigList: [],
      bigJson: {},
      cardList: [],
      cardJson: {},
      buttonList: [],
      footList: [],
      footJson: [],
      isActive: true,
      product: "",
      src: ""
    };
  },
  mounted () {
    this.orderId = this.$route.query.orderId;
    this.util.title("签约");
    this.getDetails();
  },
  methods: {
    toHide () {
      this.propJson1.isShow = false;
    },
    toHideFixedToast () {
      this.isShow = false;
    },
    pageUrl () {
      this.agreeJson.isShow = false;
      this.isActive = true;
    },
    //获取费用明细
    toShow (itm) {
      if (itm.type == 1) {
        //展示固定底部弹窗
        this.getTrail();//获取——桔子分期还款计划
      } else {
        //展示toast弹窗
        this.getCalculation();//获取——普通还款明细
      }
    },
    getTrail () {
      let _this = this;
      let param = {
        period: _this.limitModel
      };
      this.$get("/app/api/v2/juzifenqi/trail/" + this.orderId, param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.dataList = e.data;
            _this.isShow = true;
          } else {
            _this.util.toast({ msg: e.message });
          }
        })
        .catch(error => { });
    },
    getCalculation () {
      let _this = this;
      this.$get("/app/api/v1/order/trialCalculation/" + this.orderId, {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            if (_this.product) {
              //如期分期的弹窗展示
              _this.propJson1.dataArr = e.data;
              _this.propJson1.isShow = true;
            } else {
              _this.propJson.feeDesc = e.data.feeDesc;
              _this.propJson.interest = e.data.interest;
              _this.propJson.periodAmount = e.data.periodAmount;
              _this.propJson.isShow = true;
            }
          } else {
            _this.util.toast({ msg: e.message });
          }
        })
        .catch(error => { });
    },
    getDetails () {
      let param = {
        orderId: this.orderId
      };
      let _this = this;
      this.$get("/app/api/v1/signing/view", param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.product = e.data.product;
            if (e.data.product == 1) {
              //1是如期产品，2是桔子分期产品
              _this.agreeJson.isShow = _this.product;
            }
            e.data.appOrderCells.map(function (item) {
              if (item.type == "signingTop") {
                _this.orderList = item.content; //借款金额
              } else if (item.type == "bigList") {
                _this.allList.push(item);
              } else if (item.type == "card") {
                _this.cardList = item.content;
                _this.cardJson = item.head;
                _this.footJson = item.foot;
                _this.footList = item.foot.footClick;
              } else if (item.type == "button") {
                _this.buttonList = item.content;
              }
            });
            _this.allList.map(function (item) {
              item.content.map(function (itm, idx) {
                if (itm.type == 1 && idx == 0) {//type:1展示下拉框——赋初值
                  _this.limitModel = itm.rightTitle.split(',')[0]
                }
              })
            })
          } else {
            _this.util.toast({ msg: e.message });
          }
        })
        .catch(error => { });
    },
    toLoan () {
      let _this = this;
      _this.isShowLoading = true;
      this.$post("/app/api/v1/order/sign/" + this.orderId + '?period=' + this.limitModel, {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            //  进入状态页面页面——待放款页面
            this.$router.push({
              path: "/loan/applyDetail",
              query: {
                orderId: _this.orderId
              }
            });
          } else {
            _this.util.toast({ msg: e.message });
          }
          _this.isShowLoading = false;
        })
        .catch(error => { });
    },
    //去分期
    toPage (pageUrl) {
      if (this.cardList[0].isBind == 0) {
        this.util.toast({ msg: "请先完成绑卡，若已绑卡请2分钟后再签约" });
      } else {
        if (pageUrl == "") {
          //去签约
          this.toLoan();
        } else {
          window.location.href = pageUrl;
        }
      }
    },
    toBind (pageUrl) {
      if (pageUrl != "") {
        window.location.href = pageUrl;
      }
    },
    checkStatus () {
      this.isActive = !this.isActive;
    }
  }
};
</script>
<style scoped>
.apply_box {
  background: #f7f7f7;
  padding-bottom: 0.2rem;
}
.top {
  background: #e6ebff;
  width: 100%;
  height: 0.36rem;
  line-height: 0.36rem;
  text-align: center;
  font-size: 0.14rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #5983fc;
}
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
.header {
  padding: 0.14rem 0.15rem;
  /* margin-bottom: 0.1rem; */
  background: #ffffff;
  padding-bottom: 0.04rem;
}
.loanMoney {
  color: #999;
  font-size: 0.12rem;
}
.pro_detail {
  background: #ffffff;
  /* margin-bottom: 0.1rem; */
}
.bank_name,
.card_num {
  position: relative;
  top: 0.03rem;
  font-size: 0.16rem;
  color: #333;
}
.title {
  color: #333;
  font-size: 0.35rem;
  font-family: DINAlternate-Bold;
  font-weight: bold;
}
.pro_item {
  padding: 0.15rem;
  border-bottom: 1px solid #eee;
  display: flex;
  flex: 1;
  justify-content: space-between;
  color: #666;
  font-size: 0.14rem;
}
.pro_item p {
  color: #666;
  font-size: 0.14rem;
}
.pro_item .btn {
  color: #486cff;
  font-size: 0.14rem;
  text-align: center;
  margin: 0 auto;
  padding: 0.1rem;
}
.h1 {
  font-size: 0.14rem;
  color: #333;
  font-family: PingFangSC-Medium;
  font-weight: 500;
}
.line {
  display: inline-block;
  width: 3px;
  height: 0.12rem;
  background: #486cff;
}
.info_box {
  font-size: 0.11rem;
  color: #333;
  padding: 0.1rem 0.15rem 0.36rem 0.15rem;
  background: #f7f7f7;
}
.info_box .agree {
  color: #486cff;
  line-height: 0.2rem;
}
.icon_circle,
.icon_circleAct {
  position: relative;
  top: 0.02rem;
  margin-right: 0.05rem;
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url('../../assets/img/afterLoan/choice_unCheck.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.icon_circleAct {
  background: url('../../assets/img/afterLoan/checked.png') no-repeat top center;
  background-size: 100% 100%;
}
.bank_btn {
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url('../../assets/img/afterLoan/add_btn.png') no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
  text-align: center;
  margin-right: 0.1rem;
  position: relative;
  top: 0.02rem;
}
.loan_btn {
  color: #fff;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 0.5) 0%,
    rgba(81, 117, 241, 0.5) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.17rem;
  text-align: center;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
}

.pay_btn_succ {
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 0.8) 0%,
    rgba(81, 117, 241, 1) 100%
  );
}
.pro_item .look {
  color: #486cff;
  font-size: 0.13rem;
  float: right;
}
.btn_box {
  margin-top: 0.3rem;
}
.pro_item1 {
  padding: 0.15rem;
  clear: both;
  overflow: hidden;
}
.bank_icon {
  width: 0.26rem;
  height: 0.26rem;
  border-radius: 50%;
  margin-right: 0.1rem;
}
.look_icon {
  display: inline-block;
  width: 0.06rem;
  height: 0.1rem;
  background: url('../../assets/img/afterLoan/look_right.png') no-repeat top
    center;
  background-size: 100% 100%;
}

/* 固定底部分期弹窗样式 */
.shadow {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 1);
  opacity: 0.4;
  z-index: 112;
}
.toast {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  z-index: 211;
  padding: 0.2rem 0.3rem;
  height: 3.18rem;
  overflow-y: scroll;
}
.toast .title {
  font-size: 0.18rem;
  color: #333;
  text-align: center;
  margin-bottom: 0.3rem;
}
.toast .close_btn {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url('../../assets/img/afterLoan/close_btn1.png') no-repeat center
    center;
  background-size: 100%;
  position: absolute;
  right: 0.15rem;
  top: 0.25rem;
}
.toast .box {
  color: #333;
  font-size: 0.16rem;
  font-weight: 500;
  position: relative;
}
.toast .content {
  color: #999;
  font-size: 0.12rem;
  margin-top: 0.08rem;
}
.toast .money {
  position: absolute;
  right: 0.15rem;
  color: #333;
  font-size: 0.16rem;
  top: 0.15rem;
}
</style>
